"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

var _config = _interopRequireDefault(require("../../config.json"));

var errorPage = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(errorPage, _React$Component);

  var _super = (0, _createSuper2.default)(errorPage);

  function errorPage(props) {
    var _this;

    (0, _classCallCheck2.default)(this, errorPage);
    _this = _super.call(this, props);
    _this.state = {
      details: _this.props.details,
      alertMessage: "Error: Please retry later. If the error persists, contact the admin."
    };
    return _this;
  }

  (0, _createClass2.default)(errorPage, [{
    key: "loginAgain",
    value: function loginAgain() {
      window.location.href = _config.default.loginPage;
    }
  }, {
    key: "render",
    value: function render() {
      var details = this.state.details;
      var masg = details.message === "Network Error" ? "Error: Please retry later." : this.state.alertMessage;
      return /*#__PURE__*/_react.default.createElement("div", {
        style: {
          backgroundColor: "#D6EAF880"
        },
        className: "container-fluid"
      }, details.status === "error" ? /*#__PURE__*/_react.default.createElement(_antd.Alert, {
        message: masg,
        description: details.message,
        type: "error",
        showIcon: true,
        banner: true
      }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, details.status === 403 ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h1", null, "Your session has expired! Please Login again!"), /*#__PURE__*/_react.default.createElement(_antd.Button, {
        type: "primary",
        onClick: this.loginAgain
      }, "OK")) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h1", null, "We are Sorry, Page Not Found"), /*#__PURE__*/_react.default.createElement("h3", null, "The page you are looking is Temporary Unavailable. Please try after some time. If this continues please contact team."))));
    }
  }]);
  return errorPage;
}(_react.default.Component);

var _default = errorPage;
exports.default = _default;